import React from 'react';
import './styles/portfolio.css';
import NavBar from './NavBar';

export default function ComingSoon() {
  return (
    <div className="pf-root" style={{ minHeight: '100vh' }}>
      <NavBar defaultDark={false} showBack={true} />
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 'clamp(40px, 8vw, 120px)',
        paddingTop: 'calc(60px + clamp(40px, 8vw, 120px))',
      }}>
        <p style={{ fontSize: '13px', color: 'var(--muted)', marginBottom: '20px', letterSpacing: '0.03em' }}>
          Case study
        </p>
        <h1 style={{
          fontSize: 'clamp(48px, 8vw, 96px)',
          fontWeight: '700',
          letterSpacing: '-0.03em',
          lineHeight: '1.05',
          color: 'var(--text)',
          marginBottom: '28px',
        }}>
          Coming soon.
        </h1>
        <p style={{
          fontSize: 'clamp(16px, 2vw, 22px)',
          color: 'var(--muted)',
          maxWidth: '480px',
          lineHeight: '1.55',
        }}>
          This case study is still being written. Check back soon.
        </p>
      </div>
    </div>
  );
}
